export enum WebviewAppMode {
    RIDER = "rider",
    DRIVER = "driver",
    EATER = "eater",
    COURIER = "courier",
    PROVIDER = "provider",
}

export enum ParentWebviewType {
    MOBILE = "mobile",
    WEB = "web",
}

export enum WidgetAppMode {
    PROVIDER_PORTAL = "provider_portal",
    FLEET_OWNER_PORTAL = "fleet_owner_portal",
    BUSINESS_USER_PORTAL = "business_user_portal",
    BUSINESS_COMPANY_PORTAL = "business_company_portal",
    DELIVERY_FLEET_PORTAL = "delivery_fleet_portal",
    DRIVER_REGISTRATION_PORTAL = "driver_registration_portal",
    RIDE_BOOKER_PORTAL = "ride_booker_portal",
}

export enum WebformAppMode {
    WEBFORM = "webform",
}

export type AppMode = WebviewAppMode | WidgetAppMode | WebformAppMode;

export type ParentType = ParentWebviewType;
